import React, { useState } from 'react';
import css from './GeneralQuestionsFaq.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import { NamedLink } from '../../../../../components';

const accordionData = [
    {
        title: "What is this platform, and how does it work?",
        content: "Our platform is an online project management tool operating as a Collective. It connects General Contractors with a network of verified subcontractors, fostering collaboration, transparency, and mutual growth among members.",
    },
    {
        title: "What is the Collective model?",
        content: "The Collective model ensures that all members—general contractors and subcontractors—benefit from shared success. It promotes fairness, transparency, and community-driven decision-making, creating an equitable ecosystem for everyone involved.",
    },
    {
        title: "Who can join the platform?",
        content: "General Contractors and Subcontractors specializing in various trades, including painting, carpentry, electrical, and more, are welcome to join. Subcontractors must undergo a verification process to ensure quality and reliability.",
    },
    {
        title: "How can I find subcontractors for my project?",
        content: "Use our Subcontractor Network to search for verified professionals by trade, location, and project needs. You can review their profiles, ratings, and past work before hiring.",
    },
    {
        title: "Can I communicate directly with subcontractors?",
        content: "Yes, our Direct Messaging feature allows you to discuss project details, timelines, and expectations seamlessly.",
    },
];

function GeneralQuestionsFaq() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index); // Toggle current item
    };

    return (
        <div className={css.questionFaqWrapper}>
            <div className={css.faqHeading}>General Questions</div>
            <div className={css.faqBox}>
                <div className={css.accordion}>
                    {accordionData.map((item, index) => (
                        <div
                            key={index}
                            className={`${css.accordionItem} ${activeIndex === index ? css.active : ""
                                }`}
                        >
                            <div
                                className={css.accordionHeader}
                                onClick={() => toggleAccordion(index)}
                            >
                                <h3>{item.title}</h3>
                                <span className={css.icon}>
                                    {activeIndex === index ? <IconCard brand="minus" /> : <IconCard brand="plus" />}
                                </span>
                            </div>
                            <div
                                className={css.accordionContent}
                                style={{
                                    maxHeight: activeIndex === index ? "100px" : "0",
                                    padding: activeIndex === index ? "0 40px 30px" : "0 20px",
                                }}
                            >
                                <p>{item.content}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className={css.moreFaqButton}>
                <NamedLink name="FaqPage" ><button>See More FAQs</button></NamedLink>
                    
                </div>
            </div>
        </div>
    )
}

export default GeneralQuestionsFaq